// extracted by mini-css-extract-plugin
export default {"label":"TreeLabel__label--VdAl3cMWxbkZxdUWnjsX","error":"TreeLabel__error--dAOLhEzEGFvtbSy4zzaS"};